import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import KanbanColumn from './KanbanColumn';

const useStyles = makeStyles(theme => ({
  board: {
    display: 'flex',
    alignItems: 'stretch',
    width: '100%',
    height: '100%',
    minHeight: 0,
    overflowX: 'auto',
    overflowY: 'hidden',
    ...theme.scrollbarStyles,
    padding: theme.spacing(2),
    scrollBehavior: 'smooth',
    boxSizing: 'border-box',
    '@media (max-height: 850px)': {
      padding: theme.spacing(1, 1.5, 1.25),
    },
  },
}));

const KanbanBoard = ({ lanes, onCardMove, onLaneReorder, updateTicket, isAdmin, onLaneEdit }) => {
  const classes = useStyles();

  const handleDragEnd = result => {
    if (!result.destination) return;

    const { source, destination, draggableId, type } = result;

    // Se for reordenação de lane
    if (type === 'LANE') {
      const sourceLane = lanes[source.index];
      const destinationLane = lanes[destination.index];
      // Etapas automaticas participam da mesma faixa horizontal, mas continuam
      // fixas e nao entram na ordem editavel das lanes da empresa.
      if (sourceLane?.isSystem || destinationLane?.isSystem) return;
      if (source.index !== destination.index) {
        onLaneReorder(source.index, destination.index);
      }
      return;
    }

    // Se for movimentação de card
    if (
      source.droppableId !== destination.droppableId ||
      source.index !== destination.index
    ) {
      onCardMove(
        draggableId,
        destination.droppableId,
        source.droppableId,
        source.index,
        destination.index
      );
    }
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="lanes" direction="horizontal" type="LANE">
        {(provided, snapshot) => (
          <div 
            className={classes.board}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {lanes.map((lane, index) => (
              <KanbanColumn
                key={lane.id}
                id={lane.id}
                title={lane.title}
                tickets={lane.tickets}
                color={lane.color}
                index={index}
                updateTicket={updateTicket}
                isAdmin={isAdmin && !lane.isSystem}
                isSystem={!!lane.isSystem}
                onLaneEdit={onLaneEdit}
				total={lane.total}
				hasMore={lane.hasMore}
				loadingMore={lane.loadingMore}
				onLoadMore={lane.onLoadMore}
				aggregateValue={lane.aggregateValue}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default KanbanBoard;
